export default {
  body: {
    padding: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/TagDialog/styles.js